import React from "react";
import { styled } from "goober";
import { Button } from "clutch/src/Button/Button.jsx";
import { anyMedia, mobile, touchOnly } from "clutch/src/Style/style.mjs";

import { readState } from "@/__main__/app-state.mjs";
import { IS_APP } from "@/__main__/constants.mjs";
import NavSearch from "@/app/AppShellMainNavSearch.jsx";
import { MobileUserDropdown } from "@/app/AppShellUserDropdown.jsx";
import { LOCALES } from "@/app/constants.mjs";
import DownloadButtonWrapper from "@/app/DownloadButtonWrapper.jsx";
import appRefs from "@/app/refs.mjs";
import BlitzLogo from "@/inline-assets/blitz-logo.svg";
import { useSnapshot } from "@/util/use-snapshot.mjs";
// import { accountRefs } from "@/app/account.refs.mjs";

export const HEADER_DOWNLOAD_BUTTON_ID = "header-download-button";

const SearchBarWrapper = styled("div")`
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  align-self: stretch;
  position: relative;
  padding: var(--sp-3) var(--page-padding) var(--sp-1) var(--page-padding);

  &.home {
    padding: var(--sp-3) var(--sp-4);
  }

  a.icon,
  > .mobile-menu-item {
    display: none;
  }

  .search-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--sp-4);
    max-width: var(--header-container, var(--sp-container));
    margin-inline: auto;
    width: 100%;
  }

  ${anyMedia(touchOnly, mobile)} {
    gap: var(--sp-3);

    > .mobile-menu-item {
      display: flex;
    }

    > a.icon {
      display: flex;
      svg {
        width: var(--sp-7);
        height: var(--sp-7);
      }
    }
  }
`;

const SearchWrapper = styled("div")`
  width: 100%;
  max-width: var(--sp-container);

  label[for="all-search-input"] {
    height: var(--sp-9);
    > * {
      height: var(--sp-9);
    }
  }
`;

const Buttons = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--sp-3);

  .download-blitz-button {
    padding-inline: var(--sp-3);
  }

  ${anyMedia(touchOnly, mobile)} {
    display: none;
  }
`;

const TopNavSearchAndLinksBar = ({ currentPath }) => {
  const { SignIn } = useSnapshot(appRefs);

  const {
    settings: { selectedLanguage },
  } = useSnapshot(readState);

  const currentLocale = LOCALES.find(
    (lng) => Array.isArray(lng) && lng[0] === selectedLanguage,
  ) || ["en", "English"];

  return (
    <SearchBarWrapper className={currentPath === "/" ? "home" : ""}>
      <a href="/" className="icon">
        <BlitzLogo className="original-colors" />
      </a>

      <div className="search-bar">
        <SearchWrapper>
          <NavSearch />
        </SearchWrapper>

        <Buttons>
          {SignIn && <SignIn />}
          <Button emphasis="low" size="medium" as="a" href="/settings">
            {currentLocale[1]}
          </Button>
          {!IS_APP && currentPath.split("/").length > 2 && (
            <DownloadButtonWrapper
              className="download-blitz-button"
              target="_blank"
              uiLocation="APP_HEADER"
            />
          )}
        </Buttons>
      </div>
      <MobileUserDropdown />
    </SearchBarWrapper>
  );
};

export default React.memo(TopNavSearchAndLinksBar);
